// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TestPage_wrapper__3YJTG","container":"TestPage_container__2BauN"};